module.exports = __webpack_public_path__ + "img/badge80.8ddd0758.png";